<template>
  <div class="b-api-doc">
    <div class="shadow-sm bg-white mb-3">
      <div class="container-fluid container-xxl py-2">
        <div class="row">
          <div class="col-auto">
            <img
              src="@assets/logo.svg"
              alt=""
              width="64"
            >
          </div>
          <div class="col b-api-doc__title">
            <Link href="/api">
              ������������ API
            </Link>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid container-xxl py-2">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApiDocLayout',
};
</script>

<style scoped lang="scss">

  .b-api-doc {
    &__title {
      font-size: 16px;
      line-height: 30px;
    }
  }
</style>
